import React from "react";
import Loading from "components/Loading";
import TreeMap from "components/TreeMap";

import { useSchemaTableListTreeMapQuery } from "./gql/Query.generated";
import styles from "./style.module.scss";
import { useRoutes } from "utils/routes";

interface Props {
  databaseId: string;
}

const TableTreeMap: React.FunctionComponent<Props> = ({ databaseId }) => {
  const { databaseTable } = useRoutes();
  const { data, loading, error } = useSchemaTableListTreeMapQuery({
    variables: { databaseId },
  });
  if (loading || error) {
    return <Loading error={!!error} />;
  }

  const treeMapData = data.getSchemaTables.map((t) => ({
    displayName: t.tableName,
    name: `${t.schemaName}.${t.tableName}`,
    link: databaseTable(databaseId, t.id),
    size: t.lastStats?.dataSizeBytes || 0,
  }));

  return <TreeMap className={styles.treemap} data={treeMapData} />;
};

export default TableTreeMap;
